import Support from '../../../utils/support';

export default function () {
  const swiper = this;
  if (Support.touch || (swiper.params.watchOverflow && swiper.isLocked) || swiper.params.cssMode) return;
  swiper.el.style.cursor = '';
}



// WEBPACK FOOTER //
// ../src/components/core/grab-cursor/unsetGrabCursor.js